import React, { useState } from "react";
import Skill from "./Skill";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import { AiOutlineClose } from "react-icons/ai";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

function Details({ clicked, item, handleClick }) {
  const [imageIndex, setImageIndex] = useState(0);
  const numberOfImages = item.image.length;
  const next = () => {
    if (imageIndex + 1 === numberOfImages) {
      setImageIndex(0);
    } else {
      setImageIndex(imageIndex + 1);
    }
  };
  const prev = () => {
    if (imageIndex === 0) {
      setImageIndex(numberOfImages - 1);
    } else {
      setImageIndex(imageIndex - 1);
    }
  };
  const [detail, detailInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const animationVariants = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: "easeInOut",
      },
    },
  };
  if (clicked) {
    return (
      <motion.div
        className="details"
        ref={detail}
        initial="hidden"
        animate={detailInView ? "visible" : "hidden"}
        variants={animationVariants}
      >
        <div className="details-image">
          <img src={require(`../assets/${item.image[imageIndex]}`)} alt="" />
          <div className="close-btn" onClick={handleClick}>
            <AiOutlineClose size={20} color="#07062b" />
          </div>
          {numberOfImages > 1 && (
            <div className="change-images">
              <div className="switch-btn" onClick={next}>
                <MdArrowBackIos size={20} color="#07062b" />
              </div>
              <div className="switch-btn" onClick={prev}>
                <MdArrowForwardIos size={20} color="#07062b" />
              </div>
            </div>
          )}
        </div>
        <div className="project-title">{item.title}</div>
        <div className="skills">
          {item.skills.map((item, index) => (
            <Skill key={index} name={item} />
          ))}
        </div>
      </motion.div>
    );
  } else {
    <></>;
  }
}

export default Details;
